export function sanitizeLocation(loc: string) {
    loc = loc.replace(/中国/gi, '');
    loc = loc.replace(/\s/gi, '');
    loc = loc.replace(/上海上海/gi, '上海');
    loc = loc.replace(/北京北京/gi, '北京');
    loc = loc.replace(/天津天津/gi, '天津');
    loc = loc.replace(/重庆重庆/gi, '重庆');

    return loc;
}